import type { Article } from "./types";
import { articleOrder, articleImages } from "./meta";
import { articlesEn } from "./en";
import { articlesFr } from "./fr";
import { articlesDe } from "./de";
import { articlesEs } from "./es";
import { articlesPt } from "./pt";

const articlesByLang: Record<string, Record<string, Article>> = {
  en: articlesEn,
  fr: articlesFr,
  de: articlesDe,
  es: articlesEs,
  pt: articlesPt,
};

export function getArticle(lang: string, slug: string): Article | undefined {
  const langArticles = articlesByLang[lang] ?? articlesEn;
  return langArticles[slug] ?? articlesEn[slug];
}

export interface ArticleCard {
  slug: string;
  title: string;
  description: string;
  image: string;
}

export function getArticleList(lang: string): ArticleCard[] {
  const langArticles = articlesByLang[lang] ?? articlesEn;
  return articleOrder
    .map((slug) => {
      const article = langArticles[slug] ?? articlesEn[slug];
      return {
        slug,
        title: article.title,
        description: article.description,
        image: articleImages[slug] ?? articleImages["what-is-basetao-spreadsheet"],
      };
    })
    .filter((card) => Boolean(card.title));
}

export { articleOrder };